export enum FeatureDemands {
  CLOUDFLOW = "cloudflow",
}
